import { Chip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useRange } from 'react-instantsearch';
import PackageIcon from '../../../assets/icons/package.svg?react';
import useCurrencyFormat from '../../../hooks/useCurrencyFormat';
import { DISPLAYED_MAX_MOV_RANGE } from '../../state';

export default function CompanyMovFilterTag(): React.JSX.Element {
  const { t } = useTranslation(['discovery']);
  const currencyFormat = useCurrencyFormat();
  const { refine: refineMinimumOrderValue, start } = useRange({ attribute: 'max_mov' });
  const minimumOrderValue = start[1] as number;

  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>
      {minimumOrderValue < DISPLAYED_MAX_MOV_RANGE && (
        <Chip
          label={t('discovery:mov_range', { value: currencyFormat.format(minimumOrderValue) })}
          icon={<PackageIcon style={{ fill: 'currentColor' }} />}
          onDelete={() => refineMinimumOrderValue([undefined, undefined])}
        />
      )}
    </>
  );
}
